module.exports = __webpack_public_path__ + "img/kodomo_syokudo.9dcf7b83.jpg";